import { render, staticRenderFns } from "./measurements-electric-house-heading.vue?vue&type=template&id=15f8e8ca&scoped=true&"
import script from "./measurements-electric-house-heading.vue?vue&type=script&lang=ts&"
export * from "./measurements-electric-house-heading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8e8ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
